// @ts-nocheck
// TODO: tighten types after migration
import React from 'react';
import DailyMotivationalQuotes from '../AppStore/DailyMotivationalQuotes/DailyMotivationalQuotes';
import './AdminHome.css'; // Reusing existing styles

export default function AdminQuotes() {
  return (
    <div className="admin-container mx-auto w-full max-w-[1200px] px-[16px] py-[12px]">
      <div className="admin-dashboard-wrapper flex flex-col" style={{ flexDirection: 'column' }}>
          <h1 className="admin-welcome-heading mb-[2rem] w-full text-left text-[2rem] font-[800] text-text" style={{ textAlign: 'left', width: '100%', marginBottom: '2rem' }}>Daily Quotes</h1>
          <div className="w-full max-w-[800px]" style={{ width: '100%', maxWidth: '800px' }}>
            <DailyMotivationalQuotes />
          </div>
      </div>
    </div>
  );
}
